export default "__VITE_ASSET__D225BUK3__"